import { render } from "./ChangeDevice.vue?vue&type=template&id=380445c2&scoped=true"
import script from "./ChangeDevice.vue?vue&type=script&lang=js"
export * from "./ChangeDevice.vue?vue&type=script&lang=js"

import "./ChangeDevice.vue?vue&type=style&index=0&id=380445c2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380445c2"]])

export default __exports__